/**
 * Splits a raw input string on commas, newlines, and whitespace, trims each token,
 * strips leading zeros, removes empty strings, and deduplicates (preserving first-occurrence order).
 */
export function parseItemIds(raw: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const token of raw.split(/[,\n\s]+/)) {
    const trimmed = token.trim();
    if (trimmed === '') continue;
    const normalized = trimmed.replace(/^0+(?=\d)/, '');
    if (!seen.has(normalized)) {
      seen.add(normalized);
      result.push(normalized);
    }
  }

  return result;
}

const ASIN_REGEX = /^[A-Z0-9]{10}$/i;

export function isValidAsin(id: string): boolean {
  return ASIN_REGEX.test(id);
}
